import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../middleware/authMiddleware';
import { 
  LayoutDashboard, 
  UserPlus, 
  Users, 
  ActivitySquare, 
  Settings, 
  HelpCircle, 
  Megaphone,
  LogOut,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';

const Sidebar = ({ collapsed, toggleCollapse }) => {
  const location = useLocation();
  const { logout } = useAuth();

  const navItems = [
    {
      title: 'Dashboard',
      icon: <LayoutDashboard size={20} />,
      path: '/admin',
      permission: null
    },
    {
      title: 'Create Users',
      icon: <UserPlus size={20} />,
      path: '/admin/create-users',
      permission: 'create_users'
    },
    {
      title: 'Manage Users',
      icon: <Users size={20} />,
      path: '/admin/manage-users',
      permission: 'manage_users'
    },
    {
      title: 'User Activity Logs',
      icon: <ActivitySquare size={20} />,
      path: '/admin/activity-logs',
      permission: 'view_logs'
    },
    {
      title: 'Announcements',
      icon: <Megaphone size={20} />,
      path: '/admin/announcements',
      permission: 'manage_announcements'
    },
    {
      title: 'Settings',
      icon: <Settings size={20} />,
      path: '/admin/settings',
      permission: 'manage_settings'
    },
    {
      title: 'Help',
      icon: <HelpCircle size={20} />,
      path: '/admin/help',
      permission: null
    }
  ];

  return (
    <div className={`h-full bg-gray-800 text-white flex flex-col transition-all duration-300 ${collapsed ? 'w-20' : 'w-64'}`}>
      <div className="p-4 flex items-center justify-between">
        {!collapsed && <h1 className="text-xl font-bold">NSS College Cherthala</h1>}
        <button 
          onClick={toggleCollapse}
          className="text-gray-400 hover:text-white p-1 rounded-full hover:bg-gray-700"
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>

      {!collapsed && (
        <h2 className="text-sm text-gray-400 px-4 pb-4">Admin Console</h2>
      )}

      <nav className="flex-1 overflow-y-auto">
        <ul className="space-y-1 px-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center p-3 rounded-lg hover:bg-primary-base hover:bg-opacity-[0.5] transition-colors ${
                    isActive ? 'bg-primary-base' : ''
                  }`}
                  title={collapsed ? item.title : ''}
                >
                  <span className="flex-shrink-0">{item.icon}</span>
                  {!collapsed && (
                    <span className="ml-3 whitespace-nowrap">{item.title}</span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="p-4">
        <button
          onClick={logout}
          className={`flex items-center w-full p-3 rounded-lg hover:bg-red-700 transition-colors text-gray-300 hover:text-white ${
            collapsed ? 'justify-center' : ''
          }`}
          title={collapsed ? 'Logout' : ''}
        >
          <LogOut size={20} className="flex-shrink-0" />
          {!collapsed && <span className="ml-3">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;